import Plugin from 'src/plugin-system/plugin.class';
import { gsap } from "gsap";

export default class HeroPlugin extends Plugin {

    init() {

        // Überprüfen, ob das Elternelement von .hero-widget__cta im Viewport sichtbar ist
        const checkVisibility = () => {
            const ctaElement = $('.hero-widget__cta');
            if (!ctaElement.length) return;
            
            // Auf mobilen Geräten nicht ausführen
            if (window.innerWidth < 768) {
                return;
            }

            const parentElement = ctaElement.parent();
            
            // Funktion zur Überprüfung, ob ein Element im Viewport ist
            const isInViewport = (element) => {
                const rect = element[0].getBoundingClientRect();
                return (
                    rect.top >= 0 &&
                    rect.left >= 0 &&
                    rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
                    rect.right <= (window.innerWidth || document.documentElement.clientWidth)
                );
            };
            
            // Position basierend auf Sichtbarkeit ändern
            if (isInViewport(parentElement)) {
                ctaElement.removeClass('is--fixed');
                ctaElement.css('position', 'absolute');
                ctaElement.css('top', 'unset');
                ctaElement.css('left', 'unset');
                ctaElement.css('right', '0');
                ctaElement.css('bottom', '55px');
            } else {
                ctaElement.addClass('is--fixed');
                ctaElement.css('position', 'fixed');
                ctaElement.css('top', 'unset');
                ctaElement.css('left', 'unset');
                ctaElement.css('right', '110px');
                ctaElement.css('bottom', '10px');
            }
        };

        // Beim Scrollen und beim Laden der Seite prüfen
        $(window).on('scroll resize load', checkVisibility);

        // Initial prüfen
        checkVisibility();
        
        if (!$('body.home').length) {
            return;
        }

        var tl = new gsap.timeline();

        tl.to('.hero-widget__title', {
            delay: 1,
            opacity: 1,
            duration: 1.5
        }).to('.hero-widget__subtitle', {
            delay: -0.5,
            opacity: 1,
            duration: 1.5
        });

    }

}
